import { jsx as _jsx } from "react/jsx-runtime";
import { RegistryProvider, useAtomValue } from "@effect/atom-react";
import { createContext, useContext, useEffect, useEffectEvent, useMemo } from "react";
import { makeSessionAtom } from "./bridge.js";
const EditorContext = createContext(null);
/** Provider owns subscriptions. Closing an editor session is the composition root's job. */
export function EditorProvider({ session, children }) {
    const binding = useMemo(() => ({ session, state: makeSessionAtom(session) }), [session]);
    return _jsx(EditorContext.Provider, { value: binding, children: _jsx(RegistryProvider, { children: children }) });
}
function useEditorBinding() {
    const binding = useContext(EditorContext);
    if (!binding)
        throw new Error("EditorProvider is required");
    return binding;
}
export function useEditorState() {
    return useAtomValue(useEditorBinding().state);
}
export function useEditorCommands() {
    return useEditorBinding().session.commands;
}
/** Native is borrowed synchronously; the drawing component checks its concrete type.
 * Never retain a frame, place it in an Atom, or return asynchronous drawing work.
 */
export function usePreviewFrame(present) {
    const { session } = useEditorBinding();
    const onFrame = useEffectEvent(present);
    useEffect(() => session.presentFrames((native, descriptor) => onFrame(native, descriptor)), [session]);
}
